<div class="px-2 py-1 w-full text-center rounded cursor-pointer border border-green-200 hover:text-green-600 hover:bg-green-50"
  [ngClass]="{'bg-green-100 text-green-600': active(), 'bg-slate-50': !active()}"
  (click)="click()">
  {{value()}}
</div>